<template>
	<div class="full" style="box-sizing: border-box;padding: 10px;">
		<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions"
			@toolbar-button-click="list_toolbarButtonClickEvent" ref="supplierboxruletable">
		</vxe-grid>
		<vxe-button style="margin-top: 10px;float: right;" status="success" content="保存" @click="submit"></vxe-button>
	</div>

</template>
<style scoped>
	.demo_container {
		position: absolute;
		width: 800px;
		height: 500px;
		left: 100px;
		top: 100px;
		z-index: 999999;
		background-color: white;
	}
</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		props: {
			title: {
				default: () => {
					return null
				}
			},
			extra: {
				default: () => {
					return {
						purchaseCode: null
					}
				}
			},
			row: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				id: 0,
				modal: false,
				loading: false,
				tableData: [],
				list_formConfig: [{
					field: 'billCode',
					title: '采购订单',
					span:24,
					itemRender: {
						name: '$input',
						props:{
							inputprops:{
								type:'textarea'
							}
						}
					}
				}],

			}
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				if(this.extra.purchaseCode){
					let itemobj =  this.list_formConfig.find((item)=>{
						return item.field == 'billCode'
					})
					if(itemobj){
						itemobj.resetValue = this.extra.purchaseCode
						itemobj.itemRender.defaultValue = this.extra.purchaseCode
					}
				}
				gridOptions.height = '100%'
				gridOptions.toolbarConfig = null

				gridOptions.columns = [{
						type: 'seq',
						title: '序号',
						width: 50,
					}, {
						field: 'billCode',
						title: '采购订单',
					}, {
						field: 'goodscode',
						title: '产品编码',
					},
					{
						field: 'goodsname',
						title: '产品名称'
					},
					{
						field: 'goodsmodel',
						title: '规格型号',
					},
					{
						field: 'suppliername',
						title: '供应商',
					},
					{
						field: 'size',
						title: '数量',
					},
					{
						field: 'boxgauge',
						title: '盒规',
						editRender: {
							name: '$inputNumber',
							props: {
								min: 0,
								precision: 0,
							},
							// events:{
							// 	change:()=>{}
							// }
						}

					},
					{
						field: 'bingauge',
						title: '箱规',
						editRender: {
							name: '$inputNumber',
							props: {
								min: 0,
								precision: 0,
							},
							// events:{
							// 	change:()=>{}
							// }
						}
					}
				]
			},
			list(page, updateForm, other) {
				return new Promise((resolve) => {					
					this.$api.supplier.getgoodsinfoByBillCode({
						//purchaseCode: this.extra.purchaseCode,
						...page,
						...updateForm,
						...other,
					}).then((res) => {
						resolve({
							list: res
						})
					}, () => {
						resolve([])
					})
				})
			},
			listSettlementTask() {
				this.$api.supplier.listSettlementTask().then((res) => {
					this.tableData = res
				})
			},
			submit(){
				this.loading = true
				let data = this.$refs.supplierboxruletable.getTableData().fullData
				let updateRecords = this.$refs.supplierboxruletable.getRecordset().updateRecords
				this.$api.supplier.updateboxgauge({data:updateRecords}).then(()=>{
					this.loading = false
					this.$emit('submit')
					window.parent.postMessage({ type: 'boxruledata', data: data }, '*');
					//console.log(res)
				},()=>{
					this.loading = false
				})
				
				
				
				// this.$emit('submit')
				// window.parent.postMessage({ type: 'boxruledata', data: data }, '*');
			}
		},
		components: {

		}
	}
</script>